const ngDeps = {
};

export function injectNgDeps(deps) {
  Object.assign(ngDeps, deps);
};

export default ngDeps;
